import React from 'react';
import { EduGenieAvatarImg } from './edugenieBrand';

const TypingIndicator = () => (
  <div className="edugenie-msg-row is-bot" aria-live="polite" aria-label="EduGenie is typing">
    <div className="edugenie-avatar is-bot" aria-hidden="true">
      <EduGenieAvatarImg className="edugenie-brand-img" alt="" />
    </div>
    <div>
      <div className="edugenie-typing">
        <span />
        <span />
        <span />
      </div>
    </div>
  </div>
);

export default TypingIndicator;
